export const iconTheme = {
  defaultStyles: {
    // color: (theme: MapUiTheme) => theme.colors.black,
    // fill: (theme: MapUiTheme) => theme.colors.black,
  },
};
